import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/scores/page.tsx");
